import PropTypes from 'prop-types'
import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import CustomEditor from './CustomEditor'

import { Divider } from "semantic-ui-react";

import _ from "lodash";
import { dropdowneditor, dropdownoption, dropdownsearch, hightlighted, dropdownoptionslist } from './DropDownEditor.css'


export default class DropDownEditor extends Component {
  constructor(props) {
    super(props);

    _.bindAll(this, "updateSearch", "search", "handleKeys");

    this.state = {
      options: _.chain(props).get("options")
        .thru(_.cond([
          [_.isFunction, v => v(props)],
          [_.stubTrue, _.identity]
        ]))
        .sortBy(v => _.chain(v).get("value").toNumber().value())
        .thru(a => !_.eq(props.optional, false) ? [{value: '', text: ''}, ...a] : a)
        .map(o => ({ ...o, value: _.toString(_.get(o, "value")), originalValue: _.get(o, "value") }))
        .value()
    }
  }

  componentDidMount() {
    const alreadySelectedVal = _.chain(this).get("state.options")
      .find({ value: _.toString(_.get(this, "props.value")) }).get("text").defaultTo(_.get(this, "props.value")).value();
    this.search(_.defaultTo(_.get(this, "props.charPress"), alreadySelectedVal), { shouldFilter: false });
  }

  afterGuiAttached() {
    _.invoke(this, "refs.searchInput.focus");
    if (!_.get(this, "props.charPress")) {
      _.invoke(this, "refs.searchInput.select");
    }
    this.scrollToHighlighted();
  }

  getValue() {
    const highlighted = _.get(this, "state.highlight", 0);
    return _.get(this, "state.finalSelection", _.chain(this).get("state.filteredOptions").nth(highlighted).get("originalValue").value())
  }

  isPopup() {
    return true;
  }

  search(searchText = "", ops) {
    const shouldFilter = _.get(ops, "shouldFilter", true);
    const options = _.get(this, "state.options");
    const ev = ({ value = "", text = "" }) => {
      return new RegExp(_.escapeRegExp(searchText), "i").test(`${value} ${text}`)
    };
    const fops = _.chain(options).thru(_.cond([
      [_.constant(shouldFilter), v => _.filter(v, ev)],
      [_.stubTrue, _.identity]
    ])).value();

    this.setState({
      searchText: searchText,
      highlight: _.findIndex(fops, ev),
      filteredOptions: fops
    })
  }

  handleKeys(evt) {
    const options = _.get(this, "state.filteredOptions", []);
    const currentHighlight = _.get(this, "state.highlight", 0);
    const highlight = _.cond([
      [_.matches({ keyCode: 38 }), () => _.clamp(currentHighlight - 1, 0, options.length - 1)],
      [_.matches({ keyCode: 40 }), () => _.clamp(currentHighlight + 1, 0, options.length - 1)]
    ])(evt)

    if (_.includes([38, 40], evt.keyCode) && !_.isEmpty(options)) {
      evt.preventDefault();
      this.setState({
        highlight: highlight,
      }, () => {
        this.scrollToHighlighted();
      })
    }
  }

  scrollToHighlighted() {
    const scrollTop = _.get(this, "refs.optionslist.scrollTop");
    const opListHeight = _.get(this, "refs.optionslist.offsetHeight");
    const scrollBottom = scrollTop + opListHeight;
    const el = _.invoke(this, "refs.optionslist.querySelector", `.${hightlighted}`);
    const elHeight = _.get(el, "offsetHeight", 0);
    const elTop = _.get(el, "offsetTop", 0);

    const cond = _.cond([
      [v => _.inRange(v, scrollTop, scrollBottom - elHeight), _.constant(scrollTop)],
      [v => _.lt(v, scrollTop), v => scrollTop - (scrollTop - v)],
      [v => _.gt(v, scrollBottom - elHeight), v => v - opListHeight + elHeight]
    ]);

    _.set(this, "refs.optionslist.scrollTop", cond(elTop))
  }

  updateSearch = evt => {
    const searchText = _.get(evt, "target.value", "");
    this.search(searchText);
  }

  selectOption = val => () => {
    const options = _.get(this, "state.options");
    this.setState({
      finalSelection: _.chain(options).find({ value: val }).get("originalValue").value()
    }, () => {
      _.invoke(this, "props.stopEditing");
    })
  }

  render() {
    const searchText = _.get(this, "state.searchText", "");
    const filteredOptions = _.get(this, "state.filteredOptions", "");
    const highlight = _.get(this, "state.highlight", 0);

    return <div ref="editor" className={`dropdowneditor ${dropdowneditor}`} onKeyDown={this.handleKeys}>
      <input ref="searchInput" className={dropdownsearch} type="text" value={searchText} onChange={this.updateSearch}/>
      <Divider fitted/>
      <div ref="optionslist" className={dropdownoptionslist}>
        {
          _.map(filteredOptions, ({ value, text }, i) =>
            <div key={`dropdownop${value}`} onClick={this.selectOption(value)}
                 className={`dropdrownop ${dropdownoption} ${highlight === i ? hightlighted : ""}`}>
              <span>{text}</span>
            </div>)
        }
      </div>
    </div>

  }
}

DropDownEditor.propTypes = {
  optional: PropTypes.bool
}


// WEBPACK FOOTER //
// ./components/product-detail/DropDownEditor.js